import { easeSnappy, durMedium } from './easings.js';
import { prefersReducedMotion } from './prefersReducedMotion.js';

/**
 * Wraps each word in the element in a `<span class="word">` and staggers
 * their entrance on viewport enter. Walks text nodes only, so any inline
 * HTML inside the element (`<br>`, `<h1>`, `<strong>`, etc.) is preserved.
 *
 * Driven by the `stagger_words` checkbox on `title.liquid` and
 * `richtext.liquid`.
 */
export default () => ({
  init() {
    if (prefersReducedMotion()) return;

    const walker = document.createTreeWalker(this.$el, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    let node;
    while ((node = walker.nextNode())) {
      if (node.textContent.trim()) textNodes.push(node);
    }
    if (!textNodes.length) return;

    textNodes.forEach((textNode) => {
      const fragment = document.createDocumentFragment();
      // Keep whitespace runs as plain text so layout/word-spacing is intact.
      const parts = textNode.textContent.split(/(\s+)/);
      parts.forEach((part) => {
        if (!part) return;
        if (/^\s+$/.test(part)) {
          fragment.appendChild(document.createTextNode(part));
        } else {
          const span = document.createElement('span');
          span.className = 'word inline-block';
          span.textContent = part;
          fragment.appendChild(span);
        }
      });
      textNode.parentNode.replaceChild(fragment, textNode);
    });

    window.gsap.from(this.$el.querySelectorAll('.word'), {
      yPercent: 100,
      // autoAlpha (opacity + visibility) instead of opacity alone so hidden
      // words carry `visibility: hidden` — contrast checkers skip them rather
      // than flagging them as low-contrast text sitting at opacity 0.
      autoAlpha: 0,
      stagger: 0.04,
      duration: durMedium,
      ease: easeSnappy,
      scrollTrigger: {
        trigger: this.$el,
        start: 'top 85%',
        once: true,
      },
    });
  },
});
